import type { RouteRecordRaw } from "vue-router";

export const oaOfficeRoutes: RouteRecordRaw[] = [
	{
		path: "/desktopCenter/oaOffice/OaWorkbench",
		name: "OaWorkbench",
		meta: {
			title: "工作台",
			keepAlive: false,
		},
		component: () => import("@main/views/Apps/OaOffice/OaWorkbench/OaWorkbench.vue"),
	},
	{
		path: "/desktopCenter/oaOffice/approvalCenter",
		name: "ApprovalCenter",
		meta: {
			title: "审批中心",
			keepAlive: false,
		},
		component: () => import("@main/views/Apps/OaOffice/ApprovalCenter/ApprovalCenter.vue"),
	},
	{
		path: "/desktopCenter/oaOffice/OaApproval",
		name: "OaApproval",
		meta: {
			title: "OA审批",
			keepAlive: false,
		},
		redirect: "/desktopCenter/oaOffice/OaApproval/formManage",
		children: [
			{
				path: "/desktopCenter/oaOffice/OaApproval/formManage",
				name: "FormManage",
				meta: {
					title: "表单管理",
					keepAlive: false,
				},
				component: () => import("@main/views/Apps/OaOffice/OaApproval/FormManage/FormManage.vue"),
			},
			{
				path: "/desktopCenter/oaOffice/OaApproval/dataManage",
				name: "DataManage",
				meta: {
					title: "数据管理",
					keepAlive: false,
				},
				component: () => import("@main/views/Apps/OaOffice/OaApproval/DataManage/DataManage.vue"),
			},
		],
	},
	{
		path: "/desktopCenter/oaOffice/employeeManage",
		name: "EmployeeManage",
		meta: {
			title: "员工管理",
			keepAlive: false,
		},
		redirect: "/desktopCenter/oaOffice/employeeManage/employeeRoster",
		children: [
			{
				path: "/desktopCenter/oaOffice/employeeManage/employeeRoster",
				name: "EmployeeRoster",
				meta: {
					title: "花名册",
					keepAlive: false,
				},
				component: () =>
					import("@main/views/Apps/OaOffice/EmployeeManage/EmployeeRoster/EmployeeRoster.vue"),
			},
			{
				path: "/desktopCenter/oaOffice/employeeManage/fileFieldManage",
				name: "FileFieldManage",
				meta: {
					title: "档案字段管理",
					keepAlive: false,
					hideInMenu: true,
					activeMenu: "/desktopCenter/oaOffice/employeeManage/employeeRoster",
				},
				component: () =>
					import("@main/views/Apps/OaOffice/EmployeeManage/FileFieldManage/FileFieldManage.vue"),
			},
			{
				path: "/desktopCenter/oaOffice/employeeManage/employeeFiles/:id",
				name: "EmployeeFiles",
				meta: {
					title: "员工档案",
					keepAlive: false,
					hideInMenu: true,
					activeMenu: "/desktopCenter/oaOffice/employeeManage/employeeRoster",
				},
				component: () =>
					import("@main/views/Apps/OaOffice/EmployeeManage/EmployeeFiles/EmployeeFiles.vue"),
			},
		],
	},
	{
		path: "/desktopCenter/oaOffice/createForm",
		name: "OaCreateForm",
		meta: {
			title: "创建表单",
			keepAlive: false,
			hideInMenu: true,
			isFullScreen: true,
		},
		component: () => import("@main/views/Apps/OaOffice/CreateForm/CreateForm.vue"),
	},
	{
		path: "/desktopCenter/oaOffice/initiateApproval",
		name: "InitiateApproval",
		meta: {
			title: "发起审批",
			keepAlive: false,
			hideInMenu: true,
			activeMenu: "/desktopCenter/oaOffice/OaWorkbench",
		},
		component: () => import("@main/views/Apps/OaOffice/InitiateApproval/InitiateApproval.vue"),
	},
];
